import { Volume } from '@/api/type-server'

export function volumeUsage(vol: Volume) {
  const usageInGb = vol.usage_mb / 1024
  return {
    usage: usageInGb === 0 ? '0' : usageInGb.toFixed(3),
    total: vol.quota_gb || vol.last_quota_gb,
    unit: 'GB',
  }
}
